<template>
    <div v-if="showFormPoolsEmk || showFormHibernationEmk || showFormDNSEmk">
        <b-modal no-close-on-backdrop ref="kubernetesModal" size="lg" id="kubernetes-modal" title="" hide-footer>
            <f-pools-emk-form v-if="showFormPoolsEmk" :key="updateKeyForm"/>
            <f-hibernation-emk-form v-if="showFormHibernationEmk" :key="updateKeyForm"/>
            <f-dns-emk-form v-if="showFormDNSEmk" :key="updateKeyForm"/>
        </b-modal>
    </div>
    <div v-else>
        <b-modal no-close-on-backdrop ref="kubernetesModal" id="kubernetes-modal" title="" hide-footer>
            <f-upgrade-emk-form v-if="showFormUpgradeEmk" :key="updateKeyForm"/>
            <f-maintenance-emk-form v-if="showFormMaintenanceEmk" :key="updateKeyForm"/>
            <f-reconcile-emk-form v-if="showFormReconcileEmk" :key="updateKeyForm"/>
            <f-rotate-kubeconfig-emk-form v-if="showFormRotateKubeConfigEmk" :key="updateKeyForm"/>
            <f-delete-emk-form v-if="showFormDeleteEmk" :key="updateKeyForm"/>
            <f-access-emk-form v-if="showFormAccessEmk" :key="updateKeyForm"/>
            <f-addons-emk-form v-if="showFormAddonsEmk" :key="updateKeyForm"/>
            <f-emk-high-available-form v-if="showFormHAEmk" :key="updateKeyForm"/>
            <f-credentials-rotation-emk-form v-if="showFormCredentialsEmk" :key="updateKeyForm"/>
            <f-direct-hibernation-emk-form v-if="showFormDirectHibernationEmk" :key="updateKeyForm"/>
            <f-service-account-form v-if="showFormCreateServiceAccount || showFormDeleteServiceAccount || showFormResetServiceAccount" :createServiceAccount="showFormCreateServiceAccount" :deleteModal="showFormDeleteServiceAccount" :key="updateKeyForm"/>
        </b-modal>
    </div>
</template>
<script>
const fUpgradeEmkForm = () => import('@/components/forms/f-upgrade-emk-form');
const fPoolsEmkForm = () => import('@/components/forms/f-pools-emk-form');
const fMaintenanceEmkForm = () => import('@/components/forms/f-maintenance-emk-form');
const fHibernationEmkForm = () => import('@/components/forms/f-hibernation-emk-form');
const fDirectHibernationEmkForm = () => import('@/components/forms/f-direct-hibernation-emk-form');
const fReconcileEmkForm = () => import('@/components/forms/f-reconcile-emk-form');
const fRotateKubeconfigEmkForm = () => import('@/components/forms/f-rotate-kubeconfig-emk-form');
const fDeleteEmkForm = () => import('@/components/forms/f-delete-emk-form');
const fAccessEmkForm = () => import('@/components/forms/f-access-emk-form');
const fAddonsEmkForm = () => import('@/components/forms/f-addons-emk-form');
const fCredentialsRotationEmkForm = () => import('@/components/forms/f-credentials-rotation-emk-form');
const fDnsEmkForm = () => import('@/components/forms/f-dns-emk-form');
const fEmkHighAvailableForm = () => import('@/components/forms/f-emk-ha-form');
const fServiceAccountForm = () => import('@/components/forms/f-service-account-form');

export default {
    computed: {
        showFormUpgradeEmk() {
            return this.$store.state.form.showFormUpgradeEmk;
        },

        showFormPoolsEmk() {
            return this.$store.state.form.showFormPoolsEmk;
        },

        showFormMaintenanceEmk() {
            return this.$store.state.form.showFormMaintenanceEmk;
        },

        showFormHibernationEmk() {
            return this.$store.state.form.showFormHibernationEmk;
        },

        showFormDirectHibernationEmk() {
            return this.$store.state.form.showFormDirectHibernationEmk;
        },

        showFormReconcileEmk() {
            return this.$store.state.form.showFormReconcileEmk;
        },

        showFormRotateKubeConfigEmk() {
            return this.$store.state.form.showFormRotateKubeConfigEmk;
        },

        showFormDeleteEmk() {
            return this.$store.state.form.showFormDeleteEmk;
        },

        showFormAccessEmk() {
            return this.$store.state.form.showFormAccessEmk;
        },

        showFormAddonsEmk() {
            return this.$store.state.form.showFormAddonsEmk;
        },

        showFormCredentialsEmk() {
            return this.$store.state.form.showFormCredentialsEmk;
        },

        showFormDNSEmk() {
            return this.$store.state.form.showFormDNSEmk;
        },

        showFormHAEmk() {
            return this.$store.state.form.showFormHAEmk;
        },

        showFormCreateServiceAccount() {
            return this.$store.state.form.showFormCreateServiceAccount;
        },

        showFormResetServiceAccount() {
            return this.$store.state.form.showFormResetServiceAccount;
        },

        showFormDeleteServiceAccount() {
            return this.$store.state.form.showFormDeleteServiceAccount;
        },

        updateKeyForm() {
            return this.$store.state.emk.updateKeyForm;
        },
    },

    components: {
        fUpgradeEmkForm,
        fPoolsEmkForm,
        fMaintenanceEmkForm,
        fHibernationEmkForm,
        fDirectHibernationEmkForm,
        fReconcileEmkForm,
        fRotateKubeconfigEmkForm,
        fDeleteEmkForm,
        fAccessEmkForm,
        fAddonsEmkForm,
        fDnsEmkForm,
        fServiceAccountForm,
        fCredentialsRotationEmkForm,
        fEmkHighAvailableForm,
    }
}
</script>
<style>
.modal-dialog.modal-lg {
    max-width: 1200px;
}
</style>
